<!--
  Quando il componente viene aperto come dialog, MatDialog wrappa il contenuto in
  un <mat-dialog-container> con il proprio bordo/shadow: la <mat-card> qui sotto
  aggiungerebbe un secondo riquadro (doppio bordo visibile).
  La classe `is-dialog` azzera bordo/ombra della mat-card SOLO in modalità dialog,
  mantenendo l'aspetto invariato quando il componente è una route page.
-->
<mat-card [class.is-dialog]="isDialog">

  <mat-card-content>

    <h3 style="margin-left: 10px;">{{"payment" | translate}}</h3>

    <ct-form [configuration]="formConfiguration"></ct-form>

    <mat-card-actions fxLayout="row wrap" fxLayoutAlign="space-between">

      <ct-button [configuration]="cancelButton"></ct-button>

      <ct-button [configuration]="submitButton"></ct-button>

    </mat-card-actions>

  </mat-card-content>

</mat-card>
